import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedisManagerComponent } from './redis-manager.component';
import { DeleteComponent } from './modals/delete/delete.component';
import { DeleteAllComponent } from './modals/delete-all/delete-all.component';

@NgModule({
  exports: [RedisManagerComponent],
  imports: [
    CommonModule,
    DeleteComponent,
    DeleteAllComponent,
    RedisManagerComponent,
  ],
})
export class RedisManagerModule {}
